/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2022
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class VisGestureInternalAPI
 * @hideconstructor
 * @classdesc API class that is used to handle the visualization gestures
 */
define([], () => {
	class VisGestureInternalAPI {

		/**
		 * @function VisGestureInternalAPI#onMouseLeave
		 * @description handle mouse leave event
		 * @param {object} event - mouse leave event	 
		 * */
		onMouseLeave(/* event */) {}

		/**
		 * @function VisGestureInternalAPI#onMouseDown
		 * @description handle mouse down event
		 * @param {object} event - mouse down event	 
		 * * */
		onMouseDown(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onMouseUp
		 * @description handle mouse up event
		 * @param {object} event - mouse up event	 
		 * */
		onMouseUp(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onMouseWheel
		 * @description handle mouse wheel event
		 * @param {object} event - mouse wheel event
		 * */
		onMouseWheel(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onClickTapPanStart
		 * @description handle pan start event
		 * @param {object} event - pan start event	 
		 * */
		onClickTapPanStart(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onPanEnd
		 * @description handle pan end event
		 * @param {object} event - pan end event	 
		 * */
		onPanEnd(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onPanMove
		 * @description handle pan move event
		 * @param {object} event - pan move event	 
		 * */
		onPanMove(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onPinchStart
		 * @description handle pinch start event
		 * @param {object} event - pinch start event	 
		 * */
		onPinchStart(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onPinch
		 * @description handle pinch event
		 * @param {object} event - pinch event	 
		 * */
		onPinch(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onPinchEnd
		 * @description handle pinch end event
		 * @param {object} event - pinch end event	 
		 * */
		onPinchEnd(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onHover
		 * @description handle hover event
		 * @param {object} event - hover event	 
		 * */
		onHover(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onClick
		 * @description handle click event
		 * @param {object} event - click event	 
		 * */
		onClick(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onHold
		 * @description handle hold event
		 * @param {object} event - hold event	 
		 * */
		onHold(/*event*/){}

		/**
		 * @function VisGestureInternalAPI#onKeyDown
		 * @description handle key down event
		 * @param {object} event - key down event	 
		 * */
		onKeyDown(/*event*/){}

	}

	return VisGestureInternalAPI;
});
